import { createContext } from 'react';

const ErrorHandlerContext = createContext({
  errors: [],
  push: () => {},
  reset: () => {},
});

export default ErrorHandlerContext;
